import 'ace-builds';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import _ from 'lodash';
import { FC } from 'react';
import AceEditor from 'react-ace';

interface InlineJsonEditorProps {
    value: any;
    onChange: (value: any) => void;
    onBlur?: () => void;
    readOnly?: boolean;
    height?: string;
}

export const InlineJsonEditor: FC<InlineJsonEditorProps> = ({
    value,
    onChange,
    onBlur,
    readOnly = false,
    height = '300px',
}) => {
    return (
        <AceEditor
            readOnly={readOnly}
            mode='json'
            theme='github'
            value={
                _.isString(value) ? value : JSON.stringify(value, undefined, 2)
            }
            width='100%'
            height={height}
            onChange={(v) => {
                onChange(v);
            }}
            onBlur={onBlur}
            name='json_editor'
            editorProps={{ $blockScrolling: true }}
            setOptions={{
                showLineNumbers: true,
                tabSize: 2,
            }}
        />
    );
};
